
import Vue, { PropType } from 'vue';
import { FeedbackReportShot } from '@run-diffusion/shared';
import DialogOrBottomSheet from '@/components/base/DialogOrBottomSheet.vue';
import DialogContent from '@/components/base/DialogContent.vue';

// A feedback report's screenshots, or a comment's, one at a time and full size: the arrow keys (or
// the buttons) move between them, Escape closes. `index` is the one shown, or null when closed.
// A comment's screenshot carries only its size (no selection or open panels).
type ViewerShot = Pick<FeedbackReportShot, 'path' | 'w' | 'h'> & Partial<Pick<FeedbackReportShot, 'selection' | 'panels'>>;

export default Vue.extend({
	name: 'FeedbackShotViewer',
	props: {
		shots: { type: Array as PropType<ViewerShot[]>, required: true },
		urls: { type: Array as PropType<string[]>, required: true },
		index: { type: Number, default: null },
	},
	computed: {
		shot (): ViewerShot | null {
			return this.index === null ? null : this.shots[this.index] || null;
		},
		detail (): string {
			if (!this.shot) return '';
			return [
				`${this.shot.w} x ${this.shot.h}`,
				this.shot.selection?.length ? `${this.shot.selection.length} selected` : '',
				this.shot.panels?.length ? `open: ${this.shot.panels.join(', ')}` : '',
			].filter(Boolean).join(' · ');
		},
	},
	watch: {
		index: {
			immediate: true,
			handler (index: number | null) {
				if (index === null) window.removeEventListener('keydown', this.onKey);
				else window.addEventListener('keydown', this.onKey);
			},
		},
	},
	beforeDestroy () {
		window.removeEventListener('keydown', this.onKey);
	},
	methods: {
		onInput (open: boolean) {
			if (!open) this.close();
		},
		close () {
			this.$emit('show', null);
		},
		step (by: number) {
			if (this.index === null || !this.shots.length) return;
			this.$emit('show', (this.index + by + this.shots.length) % this.shots.length);
		},
		onKey (e: KeyboardEvent) {
			if (e.key === 'ArrowLeft') this.step(-1);
			else if (e.key === 'ArrowRight') this.step(1);
		},
	},
	components: {
		DialogContent,
		DialogOrBottomSheet,
	},
});
